<template>
  <div id="stars"></div>
</template>

<style>
  #stars {
    width: 100%;
    height: 42%;
    position: absolute;
    top: 0;
  }
</style>

<script>
import particlesJS from 'particles.js'

export default {
  created () {
    if (window.particlesJS === null) {
      window.particlesJS = particlesJS
    }
  },
  mounted () {
    window.particlesJS(
      'stars',
      {
        particles: {
          number: {
            value: 160,
            density: {
              enable: true,
              value_area: 400
            }
          },
          color: {
            value: '#ffffff'
          },
          opacity: {
            value: 1,
            random: true,
            anim: {
              enable: true,
              speed: 0.5,
              opacity_min: 0.8,
              sync: false
            }
          },
          shape: {
            type: 'star',
            stroke: {
              width: 0,
              color: '#000000'
            },
            polygon: {
              nb_sides: 5
            }
          },
          size: {
            value: 4,
            random: true,
            anim: {
              enable: true,
              speed: 4,
              size_min: 3
            }
          },
          line_linked: {
            enable: false
          },
          move: {
            enable: false
          }
        }
      }
    )
  }
}
</script>
